const PROGRAM_BOOK_UPDATE = 'update_program_book';
const PROGRAM_BOOK_CREATE_FILES = 'create_files_program_book';
const PROGRAM_BOOK_FETCH = 'fetch_program_book';
const PROGRAM_BOOK_ANSWERS_FETCH = 'fetch_program_book_answers';
const PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST = 'persist_program_book_of_target_answer';
const PROGRAM_BOOK_FETCH_ENTITY = 'fetch_program_book_title';
const PROGRAM_BOOK_PERSIST = 'persist_program_book';
const PROGRAM_BOOK_FETCH_FILES = 'fetch_program_book_files';
const PROGRAM_BOOK_TARGET_PERSIST = 'persist_program_book_target';
const PROGRAM_BOOK_ANSWERS_PERSIST = 'persist_program_book_answer';
const DELETE_FILE_PROGRAM_BOOK = 'delete_program_book_file';
const PROGRAM_BOOK_SMALL_FETCH = 'program_book_small_fetch';
export default {
    PROGRAM_BOOK_PERSIST,
    DELETE_FILE_PROGRAM_BOOK,
    PROGRAM_BOOK_FETCH_FILES,
    PROGRAM_BOOK_FETCH,
    PROGRAM_BOOK_ANSWERS_FETCH,
    PROGRAM_BOOK_ANSWERS_PERSIST,
    PROGRAM_BOOK_ANSWER_OF_TARGET_PERSIST,
    PROGRAM_BOOK_FETCH_ENTITY,
    PROGRAM_BOOK_TARGET_PERSIST,
    PROGRAM_BOOK_CREATE_FILES,
    PROGRAM_BOOK_UPDATE,
    PROGRAM_BOOK_SMALL_FETCH,
};
